import { render, staticRenderFns } from "./HazmatModalScalesByWeight.vue?vue&type=template&id=2cb243c8&scoped=true"
import script from "./HazmatModalScalesByWeight.vue?vue&type=script&lang=js"
export * from "./HazmatModalScalesByWeight.vue?vue&type=script&lang=js"
import style0 from "./HazmatModalScalesByWeight.vue?vue&type=style&index=0&id=2cb243c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb243c8",
  null
  
)

export default component.exports